import {
  QualityControlCalendarDTO,
  QualityControlCalendarListItemDTO,
  QualityControlMonthsDTO,
} from '@/../client-generator/generated-clients/quality';
import qualityClient from '@/core/api/quality-service';
import { LOADING_CONTENT } from '@/core/store/types/action-types';
import { Component, Emit, Vue } from 'vue-property-decorator';

import i18n from '@/core/translations/i18n';
import moment from 'moment';

@Component
export default class QualityControlsList extends Vue {
  @Emit('noControlsFound')
  noControlsFound() {
    return true;
  }

  qualityControls: QualityControlCalendarListItemDTO[] = [];
  hasAnyControl = true;
  theYear = moment().locale(i18n.locale);
  currentYear = '';

  get months() {
    const months: { name: string; index: number }[] = [];

    for (let i = 0; i < 12; i++) {
      months.push({
        name: this.theYear.month(i).format('MMM'),
        index: i,
      });
    }

    return months;
  }

  mounted() {
    this.fetchQualityControls();
  }

  async fetchQualityControls() {
    const currentYearTemp = this.theYear.year().toString();

    this.$store.dispatch(LOADING_CONTENT, true);

    try {
      const response = (await qualityClient.myControlCalendar(currentYearTemp, undefined)) as QualityControlCalendarDTO;
      this.qualityControls = response.controls!;
      this.hasAnyControl = response.hasAnyControl!;
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.currentYear = currentYearTemp;

      if (!this.hasAnyControl) {
        this.noControlsFound();
      }
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }

  schedulePrevious() {
    this.theYear = this.theYear.subtract(1, 'year');
    this.fetchQualityControls();
  }

  scheduleNext() {
    this.theYear = this.theYear.add(1, 'year');
    this.fetchQualityControls();
  }

  hasControl(qualityControlMonths: QualityControlMonthsDTO[], month: { name: string; index: number }) {
    return !!qualityControlMonths.find((m) => Number(m.monthStrNum) === month.index + 1);
  }

  extractMonthProp(
    monthIndex: number,
    QAList: QualityControlMonthsDTO[],
    prop: 'year' | 'month' | 'operativeArea' | 'controlManager'
  ): string | undefined {
    if (!QAList) return undefined;
    const month = QAList.find((m) => +m.monthStrNum! === monthIndex + 1);
    const propToReturn = month ? month[prop] : '';
    if (prop === 'month' && !!propToReturn) return propToReturn.split(' ').pop();
    return propToReturn;
  }
}
